import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";

const BtnInicioMatricula = ({ mostrarRequisitosAlerta, setMostrarRequisitosAlerta }) => {
  let {
    procesoMatricula,
    setProcesoMatricula,
    seteoDeObjectMatricula,
    obtenerDatosEstudiante,
    listadoRequisitosMatricula,
    matriculaAutomatica, setMatriculaAutomatica
  } = useMatricula();

  let { ckeckValidator, setCkeckValidator } = useProcesoMatricula();
  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});
  const [disableButton, setDisableButton] = useState(true);


  const {
    cpersona,
    cprograma,
    cperiodo,
    dpersona,
    dprograma,
    dperiodo,
    dprofesor,
    fmatricula,
    tcorreo,
    calumno,
    cfoto,
    bdefecto,
    cinstitucion,
    finiciomatricula,
    ffinmatricula,
    finicioclases,
    ffinclases,
    pasomatricula,
    fsistema,
  } = obtenerDatosEstudiante || {};

  const navigate = useNavigate();

  useEffect(() => {
    if (listadoRequisitosMatricula.length > 0) {
      const requisitosIncompletos = listadoRequisitosMatricula.some(requisito => requisito.bcompletado === false);
      setMostrarRequisitosAlerta(requisitosIncompletos);
    }

    let validarCkeck = listadoRequisitosMatricula.filter((dat) => {
      return [dat.bcompletado].indexOf(false) !== -1;
    });

    validarCkeck.length > 0
      ? setCkeckValidator(false)
      : setCkeckValidator(true);

  }, [listadoRequisitosMatricula]);

  let fechaActual = new Date(`${fsistema}`);
  let fechaInicio = new Date(`${finiciomatricula}`);

  let fechaFin = new Date(`${ffinmatricula}`);

  const validarBtnMatricula = () => {

    if (
      fechaActual >= fechaInicio &&
      fechaActual <= fechaFin 
      &&
      ckeckValidator
    ) {
      navigate("/matricula");

      return;
    }


  };

  useEffect(() => {

    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        msj_iniciar_proceso: obtenerLabelEtiqueta(
          "lbl_home_msj_iniciar_proceso",
          listadoEtiquetas
        ),
        fecha_matricula: obtenerLabelEtiqueta(
          "lbl_home_fecha_matricula",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);

  useEffect(() => {
    if (fechaActual >= fechaInicio &&
      fechaActual <= fechaFin 
      &&
      ckeckValidator 
      && matriculaAutomatica == false) {
        setDisableButton(false)
    } else {
      setDisableButton(true)
    }
  }, [matriculaAutomatica, ckeckValidator]);

  const { msj_iniciar_proceso, fecha_matricula } = etiquetas;

  return (
    <div className="my-3 text-center">
      {listadoRequisitosMatricula.length > 0 && obtenerDatosEstudiante.hasOwnProperty('fsistema') == true && <button
        onClick={validarBtnMatricula}
        className={`btn ${!disableButton
          ? "btn-primary"
          : "btn-deshabilitado"
          }  w-100 mb-3 d-inline-block`}
        disabled={disableButton}
      >
        <a

          className="text-decoration-none text-white"
        >
          {" "}
          {msj_iniciar_proceso}
        </a>
      </button>}


      <p className="mb-4">
        <span className="fw-medium ">{fecha_matricula}:</span> {fmatricula}
      </p>
    </div>
  );
};

export default BtnInicioMatricula;
